export default __webpack_public_path__ + "static/media/student.daf3ab5c.webp";